import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.find-index.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import Base from "./Base";
import { action, computed, makeObservable, observable, reaction, runInAction } from "mobx";
import { handle, constructRestaurantDetailsUrl, distanceBetweenCoordinates } from "@dp/common";
import DPServices from "@dp/services";
import WaitListVisibilityModel from "./models/WaitListVisibilityModel ";
import i18next from "i18next";
export var WaitListVisibityRoute;

(function (WaitListVisibityRoute) {
  WaitListVisibityRoute["AUTO_CHECKIN_INPROGRESS"] = "AUTO_CHECKIN_INPROGRESS";
  WaitListVisibityRoute["FULL_WAITLIST_VISIBILITY"] = "FULL_WAITLIST_VISIBILITY";
  WaitListVisibityRoute["AUTO_CHECKIN_ERROR"] = "AUTO_CHECKIN_ERROR";
  WaitListVisibityRoute["AUTO_CHECKIN_SUCCESS_WO_FWLV"] = "AUTO_CHECKIN_SUCCESS_WO_FWLV";
  WaitListVisibityRoute["GUEST_WAITLIST_COMPLETED"] = "GUEST_WAITLIST_COMPLETED";
  WaitListVisibityRoute["GUEST_ALREADY_SEATED"] = "GUEST_ALREADY_SEATED";
  WaitListVisibityRoute["GUEST_WAITLIST_CANCELLED"] = "GUEST_WAITLIST_CANCELLED";
  WaitListVisibityRoute["GUEST_NOTIFIED"] = "GUEST_NOTIFIED";
  WaitListVisibityRoute["GUEST_EXCEEDS_WAITLIST_POSITION_THRESHOLD"] = "GUEST_EXCEEDS_WAITLIST_POSITION_THRESHOLD";
  WaitListVisibityRoute["GET_WAITLIST_DETAILS_ERROR"] = "GET_WAITLIST_DETAILS_ERROR";
})(WaitListVisibityRoute || (WaitListVisibityRoute = {}));

export var WaitListUserStatus;

(function (WaitListUserStatus) {
  WaitListUserStatus["NotYetArrived"] = "NotYetArrived";
  WaitListUserStatus["Arrived"] = "Arrived";
  WaitListUserStatus["Notified"] = "Notified";
  WaitListUserStatus["Seated"] = "Seated";
  WaitListUserStatus["Completed"] = "Completed";
  WaitListUserStatus["Cancelled"] = "Cancelled";
})(WaitListUserStatus || (WaitListUserStatus = {}));

var ErrorHandlingFromAPI;

(function (ErrorHandlingFromAPI) {
  ErrorHandlingFromAPI[ErrorHandlingFromAPI["FromGetWaitlist"] = 0] = "FromGetWaitlist";
  ErrorHandlingFromAPI[ErrorHandlingFromAPI["FromCancelWaitlist"] = 1] = "FromCancelWaitlist";
  ErrorHandlingFromAPI[ErrorHandlingFromAPI["FromCheckinWaitlist"] = 2] = "FromCheckinWaitlist";
})(ErrorHandlingFromAPI || (ErrorHandlingFromAPI = {}));

var WaitListVisibility = (_class = /*#__PURE__*/function (_Base) {
  _inherits(WaitListVisibility, _Base);

  var _super = _createSuper(WaitListVisibility);

  function WaitListVisibility(rootStore) {
    var _this;

    _classCallCheck(this, WaitListVisibility);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "waitListVisibilityModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "_route", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_storeName", _descriptor2, _assertThisInitialized(_this));

    _this.rootStore = rootStore;
    _this.appMessages = rootStore.appMessages;
    _this.waitListVisibilityModel = new WaitListVisibilityModel(rootStore.platformUtil);
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(WaitListVisibility, [{
    key: "setupReactions",
    value: function setupReactions() {
      var _this2 = this; // get PDF menu on rest change


      reaction(function () {
        var _this2$waitListVisibi;

        return {
          restaurantNum: (_this2$waitListVisibi = _this2.waitListVisibilityModel) === null || _this2$waitListVisibi === void 0 ? void 0 : _this2$waitListVisibi.restaurantDetails
        };
      }, function (data) {
        var _this2$waitListVisibi2;

        if (data !== null && data !== void 0 && data.restaurantNum && (_this2$waitListVisibi2 = _this2.waitListVisibilityModel) !== null && _this2$waitListVisibi2 !== void 0 && _this2$waitListVisibi2.restaurantDetails) {
          _this2.getPDFMenuURL();
        }
      });
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$rootStore, _this$rootStore$user;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rootStore.platformUtil.hydrateUsingLocalStorage("WaitlistVisibility", this.waitListVisibilityModel);

              case 2:
                this.analyticsModel = (_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user = _this$rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.analyticsModel;

                this._procesSessionDetails(this.rootStore.user.sessionDetails);

                this._processAppAttributes(this.rootStore.common.appAttributes);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "getRestaurantDetails",
    value: function () {
      var _getRestaurantDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(restNumber) {
        var _yield$handle, _yield$handle2, restaurantError, restaurant, _this$waitListVisibil, _this$analyticsModel;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return handle( // TODO(RD): Confirm this works
                DPServices.Restaurant.getRestaurantDetailsByNumber(restNumber));

              case 2:
                _yield$handle = _context4.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                restaurantError = _yield$handle2[0];
                restaurant = _yield$handle2[1];

                if (!restaurantError) {
                  (_this$waitListVisibil = this.waitListVisibilityModel) === null || _this$waitListVisibil === void 0 ? void 0 : _this$waitListVisibil.setRestaurantDetails(restaurant);
                  this.waitListVisibilityModel.corporationID = restaurant === null || restaurant === void 0 ? void 0 : restaurant.corporationNumber;
                  (_this$analyticsModel = this.analyticsModel) === null || _this$analyticsModel === void 0 ? void 0 : _this$analyticsModel.setRestaurantDetailData(restaurant);
                }

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getRestaurantDetails(_x) {
        return _getRestaurantDetails.apply(this, arguments);
      }

      return getRestaurantDetails;
    }()
  }, {
    key: "_procesSessionDetails",
    value: function _procesSessionDetails(sessionDetails) {
      var _this$waitListVisibil2;

      (_this$waitListVisibil2 = this.waitListVisibilityModel) === null || _this$waitListVisibil2 === void 0 ? void 0 : _this$waitListVisibil2.setSessionDetails(sessionDetails);
    }
  }, {
    key: "_processAppAttributes",
    value: function _processAppAttributes(appAttributes) {
      var _this$waitListVisibil3;

      (_this$waitListVisibil3 = this.waitListVisibilityModel) === null || _this$waitListVisibil3 === void 0 ? void 0 : _this$waitListVisibil3.setAppAttributes(appAttributes);
    } // checks all the required conditions and do checkin

  }, {
    key: "tryCheckIn",
    value: function () {
      var _tryCheckIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var currentLocation, _currentLocation$coor, _currentLocation$coor2, _restObj$contactDetai, _restObj$contactDetai2, _this$waitListVisibil4, coordsObj, restObj, coords, distance, _this$analyticsModel2, _this$waitListVisibil5, _this$waitListVisibil6, _this$waitListVisibil7, _this$waitListVisibil8, _this$waitListVisibil9, _this$waitListVisibil10, _this$waitListVisibil11, _this$waitListVisibil12, _this$analyticsModel3, _this$waitListVisibil13, _this$waitListVisibil14, _this$waitListVisibil15, _this$waitListVisibil16, _this$waitListVisibil17, _this$waitListVisibil18, _this$waitListVisibil19, _this$waitListVisibil20, _this$analyticsModel4, _this$waitListVisibil21, _this$waitListVisibil22, _this$waitListVisibil23, _this$waitListVisibil24, _this$waitListVisibil25, _this$waitListVisibil26, _this$waitListVisibil27, _this$waitListVisibil28, _this$analyticsModel5, _this$waitListVisibil29, _this$waitListVisibil30, _this$waitListVisibil31, _this$waitListVisibil32, _this$waitListVisibil33, _this$waitListVisibil34, _this$waitListVisibil35, _this$waitListVisibil36;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.rootStore.user.obtainUserGeoCoordinates(true, 120000, 0);

              case 2:
                _context5.next = 4;
                return this.rootStore.user.currentUserLocation;

              case 4:
                currentLocation = _context5.sent;

                if (!this.waitListVisibilityModel.enableGeoFence) {
                  _context5.next = 29;
                  break;
                }

                if (!currentLocation) {
                  _context5.next = 23;
                  break;
                }

                coordsObj = {
                  latitude: currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor = currentLocation.coords) === null || _currentLocation$coor === void 0 ? void 0 : _currentLocation$coor.latitude,
                  longitude: currentLocation === null || currentLocation === void 0 ? void 0 : (_currentLocation$coor2 = currentLocation.coords) === null || _currentLocation$coor2 === void 0 ? void 0 : _currentLocation$coor2.longitude,
                  accuracy: null,
                  altitude: null,
                  altitudeAccuracy: null,
                  heading: null,
                  speed: null
                };
                restObj = this.waitListVisibilityModel.restaurantDetails;
                coords = restObj === null || restObj === void 0 ? void 0 : (_restObj$contactDetai = restObj.contactDetail) === null || _restObj$contactDetai === void 0 ? void 0 : (_restObj$contactDetai2 = _restObj$contactDetai.address) === null || _restObj$contactDetai2 === void 0 ? void 0 : _restObj$contactDetai2.coordinates;
                distance = distanceBetweenCoordinates({
                  longitude: coordsObj.longitude,
                  latitude: coordsObj.latitude
                }, {
                  longitude: coords === null || coords === void 0 ? void 0 : coords.longitude,
                  latitude: coords === null || coords === void 0 ? void 0 : coords.latitude
                }); // convert miles into meter

                distance = distance * 1609.34; // Checkin only if user is in the given threshold radius

                if (!(distance < +((_this$waitListVisibil4 = this.waitListVisibilityModel) === null || _this$waitListVisibil4 === void 0 ? void 0 : _this$waitListVisibil4.geoFenceLocationRadius))) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 15;
                return this._doCheckin();

              case 15:
                _context5.next = 21;
                break;

              case 17:
                this.analyticsModel.dispatchDisplayModalEvent("Retry in different location", "Asks user to come closer to restaurant and try checkin again", "RetryLocationModal | Remote checkin", {}); // set analytics data

                (_this$analyticsModel2 = this.analyticsModel) === null || _this$analyticsModel2 === void 0 ? void 0 : _this$analyticsModel2.setPageAnalyticsDetails({
                  pageName: "".concat((_this$waitListVisibil5 = this.waitListVisibilityModel) === null || _this$waitListVisibil5 === void 0 ? void 0 : (_this$waitListVisibil6 = _this$waitListVisibil5.appAttributes) === null || _this$waitListVisibil6 === void 0 ? void 0 : (_this$waitListVisibil7 = _this$waitListVisibil6.concept) === null || _this$waitListVisibil7 === void 0 ? void 0 : (_this$waitListVisibil8 = _this$waitListVisibil7.conceptCode) === null || _this$waitListVisibil8 === void 0 ? void 0 : _this$waitListVisibil8.toLowerCase(), "|waitlist outside radius"),
                  pageType: "".concat((_this$waitListVisibil9 = this.waitListVisibilityModel) === null || _this$waitListVisibil9 === void 0 ? void 0 : (_this$waitListVisibil10 = _this$waitListVisibil9.appAttributes) === null || _this$waitListVisibil10 === void 0 ? void 0 : (_this$waitListVisibil11 = _this$waitListVisibil10.concept) === null || _this$waitListVisibil11 === void 0 ? void 0 : (_this$waitListVisibil12 = _this$waitListVisibil11.conceptCode) === null || _this$waitListVisibil12 === void 0 ? void 0 : _this$waitListVisibil12.toLowerCase(), "|waitlist outside radius")
                });
                (_this$analyticsModel3 = this.analyticsModel) === null || _this$analyticsModel3 === void 0 ? void 0 : _this$analyticsModel3.setWaitListData({
                  position: (_this$waitListVisibil13 = this.waitListVisibilityModel) === null || _this$waitListVisibil13 === void 0 ? void 0 : (_this$waitListVisibil14 = _this$waitListVisibil13.visitIdLocalStatus) === null || _this$waitListVisibil14 === void 0 ? void 0 : _this$waitListVisibil14.initialPosition.toString(),
                  numberOfGuests: "".concat(this === null || this === void 0 ? void 0 : (_this$waitListVisibil15 = this.waitListVisibilityModel) === null || _this$waitListVisibil15 === void 0 ? void 0 : (_this$waitListVisibil16 = _this$waitListVisibil15.visitData) === null || _this$waitListVisibil16 === void 0 ? void 0 : _this$waitListVisibil16.partySize),
                  waitTime: (_this$waitListVisibil17 = this.waitListVisibilityModel) === null || _this$waitListVisibil17 === void 0 ? void 0 : (_this$waitListVisibil18 = _this$waitListVisibil17.visitData) === null || _this$waitListVisibil18 === void 0 ? void 0 : (_this$waitListVisibil19 = _this$waitListVisibil18.quote) === null || _this$waitListVisibil19 === void 0 ? void 0 : _this$waitListVisibil19.exactTime,
                  token: (_this$waitListVisibil20 = this.waitListVisibilityModel) === null || _this$waitListVisibil20 === void 0 ? void 0 : _this$waitListVisibil20.token,
                  locationRadius: "asks user to come closer to restaurant and try checkin again"
                });
                this.waitListVisibilityModel.showRetryLocationModal = true;

              case 21:
                _context5.next = 27;
                break;

              case 23:
                // to show the retry location popup
                this.analyticsModel.dispatchDisplayModalEvent("Show location Permisson Modal", "Asks user to enable location and try again", "LocationPermissionModal | Remote checkin", {}); // set analytics data

                (_this$analyticsModel4 = this.analyticsModel) === null || _this$analyticsModel4 === void 0 ? void 0 : _this$analyticsModel4.setPageAnalyticsDetails({
                  pageName: "".concat((_this$waitListVisibil21 = this.waitListVisibilityModel) === null || _this$waitListVisibil21 === void 0 ? void 0 : (_this$waitListVisibil22 = _this$waitListVisibil21.appAttributes) === null || _this$waitListVisibil22 === void 0 ? void 0 : (_this$waitListVisibil23 = _this$waitListVisibil22.concept) === null || _this$waitListVisibil23 === void 0 ? void 0 : (_this$waitListVisibil24 = _this$waitListVisibil23.conceptCode) === null || _this$waitListVisibil24 === void 0 ? void 0 : _this$waitListVisibil24.toLowerCase(), "|waitlist enable location"),
                  pageType: "".concat((_this$waitListVisibil25 = this.waitListVisibilityModel) === null || _this$waitListVisibil25 === void 0 ? void 0 : (_this$waitListVisibil26 = _this$waitListVisibil25.appAttributes) === null || _this$waitListVisibil26 === void 0 ? void 0 : (_this$waitListVisibil27 = _this$waitListVisibil26.concept) === null || _this$waitListVisibil27 === void 0 ? void 0 : (_this$waitListVisibil28 = _this$waitListVisibil27.conceptCode) === null || _this$waitListVisibil28 === void 0 ? void 0 : _this$waitListVisibil28.toLowerCase(), "|waitlist enable location")
                });
                (_this$analyticsModel5 = this.analyticsModel) === null || _this$analyticsModel5 === void 0 ? void 0 : _this$analyticsModel5.setWaitListData({
                  position: (_this$waitListVisibil29 = this.waitListVisibilityModel) === null || _this$waitListVisibil29 === void 0 ? void 0 : (_this$waitListVisibil30 = _this$waitListVisibil29.visitIdLocalStatus) === null || _this$waitListVisibil30 === void 0 ? void 0 : _this$waitListVisibil30.initialPosition.toString(),
                  numberOfGuests: "".concat((_this$waitListVisibil31 = this.waitListVisibilityModel) === null || _this$waitListVisibil31 === void 0 ? void 0 : (_this$waitListVisibil32 = _this$waitListVisibil31.visitData) === null || _this$waitListVisibil32 === void 0 ? void 0 : _this$waitListVisibil32.partySize),
                  waitTime: (_this$waitListVisibil33 = this.waitListVisibilityModel) === null || _this$waitListVisibil33 === void 0 ? void 0 : (_this$waitListVisibil34 = _this$waitListVisibil33.visitData) === null || _this$waitListVisibil34 === void 0 ? void 0 : (_this$waitListVisibil35 = _this$waitListVisibil34.quote) === null || _this$waitListVisibil35 === void 0 ? void 0 : _this$waitListVisibil35.exactTime,
                  token: (_this$waitListVisibil36 = this.waitListVisibilityModel) === null || _this$waitListVisibil36 === void 0 ? void 0 : _this$waitListVisibil36.token,
                  locationEnabled: false,
                  locationError: "asks user to enable location and try again"
                });
                this.waitListVisibilityModel.showLocationPermissionModal = true;

              case 27:
                _context5.next = 30;
                break;

              case 29:
                // error message when geo fence is false
                this.appMessages.showError("Sorry", "Restaurant did not enable remote checkin currently");

              case 30:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function tryCheckIn() {
        return _tryCheckIn.apply(this, arguments);
      }

      return tryCheckIn;
    }()
  }, {
    key: "getPDFMenuURL",
    value: function () {
      var _getPDFMenuURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _DPServices$Restauran, _this$waitListVisibil37, _this$waitListVisibil38;

        var pdfMenuConfig;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return DPServices === null || DPServices === void 0 ? void 0 : (_DPServices$Restauran = DPServices.Restaurant) === null || _DPServices$Restauran === void 0 ? void 0 : _DPServices$Restauran.getRestaurantPDFMenuURL((_this$waitListVisibil37 = this.waitListVisibilityModel) === null || _this$waitListVisibil37 === void 0 ? void 0 : (_this$waitListVisibil38 = _this$waitListVisibil37.restaurantDetails) === null || _this$waitListVisibil38 === void 0 ? void 0 : _this$waitListVisibil38.restaurantNumber);

              case 2:
                pdfMenuConfig = _context6.sent;
                this.waitListVisibilityModel.pdfMenuUrl = pdfMenuConfig;

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getPDFMenuURL() {
        return _getPDFMenuURL.apply(this, arguments);
      }

      return getPDFMenuURL;
    }() // intial function that calls on page load

  }, {
    key: "tryAutoCheckin",
    value: function () {
      var _tryAutoCheckin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref) {
        var corporationId, token, locationNumber, visitId, _this$waitListVisibil39, _this$waitListVisibil40, _this$waitListVisibil41, _this$waitListVisibil42, _this$waitListVisibil43, _this$waitListVisibil44;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                corporationId = _ref.corporationId, token = _ref.token, locationNumber = _ref.locationNumber, visitId = _ref.visitId; // clearing the route everytime to remove stale route.

                this.route = null;

                if (!token) {
                  _context7.next = 11;
                  break;
                }

                _context7.next = 5;
                return this.getWaitlistDataByVisitToken(token);

              case 5:
                if (!this.waitListVisibilityModel.locationNumber) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 8;
                return this.getRestaurantDetails(this.waitListVisibilityModel.locationNumber);

              case 8:
                // set the route accordingly to the status
                this.setUserStatus((_this$waitListVisibil39 = this.waitListVisibilityModel) === null || _this$waitListVisibil39 === void 0 ? void 0 : (_this$waitListVisibil40 = _this$waitListVisibil39.visitData) === null || _this$waitListVisibil40 === void 0 ? void 0 : _this$waitListVisibil40.status);
                _context7.next = 20;
                break;

              case 11:
                if (!(corporationId && locationNumber && visitId)) {
                  _context7.next = 19;
                  break;
                }

                _context7.next = 14;
                return this.getWaitlistDataByVisitID(corporationId, locationNumber, visitId);

              case 14:
                _context7.next = 16;
                return this.getRestaurantDetails(this.waitListVisibilityModel.locationNumber);

              case 16:
                // set the route accordingly to the status
                this.setUserStatus((_this$waitListVisibil41 = this.waitListVisibilityModel) === null || _this$waitListVisibil41 === void 0 ? void 0 : (_this$waitListVisibil42 = _this$waitListVisibil41.visitData) === null || _this$waitListVisibil42 === void 0 ? void 0 : _this$waitListVisibil42.status);
                _context7.next = 20;
                break;

              case 19:
                // if all the required attributes are not present in the URL
                this.appMessages.showError("Something went wrong", "please check the url and try again");

              case 20:
                if (!((this.waitListVisibilityModel.isByVisitId || this.waitListVisibilityModel.isByVisitToken) && this.waitListVisibilityModel.isRemoteCheckinEnabled)) {
                  _context7.next = 24;
                  break;
                }

                if (!(((_this$waitListVisibil43 = this.waitListVisibilityModel) === null || _this$waitListVisibil43 === void 0 ? void 0 : (_this$waitListVisibil44 = _this$waitListVisibil43.visitData) === null || _this$waitListVisibil44 === void 0 ? void 0 : _this$waitListVisibil44.status) === WaitListUserStatus.NotYetArrived && this.route !== WaitListVisibityRoute.GET_WAITLIST_DETAILS_ERROR)) {
                  _context7.next = 24;
                  break;
                }

                _context7.next = 24;
                return this.tryCheckIn();

              case 24:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function tryAutoCheckin(_x2) {
        return _tryAutoCheckin.apply(this, arguments);
      }

      return tryAutoCheckin;
    }()
  }, {
    key: "whenAppActive",
    value: function () {
      var _whenAppActive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this$waitListVisibil45, _this$waitListVisibil46, _this$waitListVisibil47, _this$waitListVisibil48;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this.route !== (WaitListVisibityRoute === null || WaitListVisibityRoute === void 0 ? void 0 : WaitListVisibityRoute.GET_WAITLIST_DETAILS_ERROR))) {
                  _context8.next = 3;
                  break;
                }

                _context8.next = 3;
                return this.tryAutoCheckin({
                  corporationId: (_this$waitListVisibil45 = this.waitListVisibilityModel) === null || _this$waitListVisibil45 === void 0 ? void 0 : _this$waitListVisibil45.corporationID,
                  token: (_this$waitListVisibil46 = this.waitListVisibilityModel) === null || _this$waitListVisibil46 === void 0 ? void 0 : _this$waitListVisibil46.token,
                  locationNumber: (_this$waitListVisibil47 = this.waitListVisibilityModel) === null || _this$waitListVisibil47 === void 0 ? void 0 : _this$waitListVisibil47.locationNumber,
                  visitId: (_this$waitListVisibil48 = this.waitListVisibilityModel) === null || _this$waitListVisibil48 === void 0 ? void 0 : _this$waitListVisibil48.visitID
                });

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function whenAppActive() {
        return _whenAppActive.apply(this, arguments);
      }

      return whenAppActive;
    }()
  }, {
    key: "getWaitlistDataByVisitID",
    value: function () {
      var _getWaitlistDataByVisitID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(corporationId, locationNumber, visitId) {
        var _this$waitListVisibil49, _this$waitListVisibil50, _this$waitListVisibil51, resp, _this$waitListVisibil52, _this$waitListVisibil53, localStatus, _error$response, _error$response$data, error;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return DPServices.Waitlist.getVisitByVisitID({
                  concept: (_this$waitListVisibil49 = this.waitListVisibilityModel) === null || _this$waitListVisibil49 === void 0 ? void 0 : (_this$waitListVisibil50 = _this$waitListVisibil49.appAttributes) === null || _this$waitListVisibil50 === void 0 ? void 0 : (_this$waitListVisibil51 = _this$waitListVisibil50.concept) === null || _this$waitListVisibil51 === void 0 ? void 0 : _this$waitListVisibil51.conceptCode,
                  corporationId: corporationId,
                  locationNumber: parseInt(locationNumber),
                  visitId: visitId
                });

              case 3:
                resp = _context9.sent;

                if ("visit" in resp) {
                  // Check if we have local status for the visit and return the status accordingly
                  localStatus = this._getLocalVisitStatus(resp, visitId);
                  resp.visit = _objectSpread(_objectSpread({}, resp === null || resp === void 0 ? void 0 : resp.visit), {}, {
                    status: localStatus
                  });
                  this.waitListVisibilityModel.setVisitData(resp === null || resp === void 0 ? void 0 : resp.visit);
                  this.waitListVisibilityModel.setFullWaitlist(resp === null || resp === void 0 ? void 0 : resp.waitlist); // if position exceeds the threshold returning to show check back later screen

                  this.checkIfUserPositionExceedsThreshold(((_this$waitListVisibil52 = this.waitListVisibilityModel) === null || _this$waitListVisibil52 === void 0 ? void 0 : (_this$waitListVisibil53 = _this$waitListVisibil52.fullWaitlist) === null || _this$waitListVisibil53 === void 0 ? void 0 : _this$waitListVisibil53.findIndex(function (item) {
                    return item.user;
                  })) + 1); // set from visit id and values in the model

                  this.waitListVisibilityModel.corporationID = corporationId;
                  this.waitListVisibilityModel.locationNumber = locationNumber;
                  this.waitListVisibilityModel.visitID = visitId;
                  this.waitListVisibilityModel.isByVisitId = true;
                }

                _context9.next = 12;
                break;

              case 7:
                _context9.prev = 7;
                _context9.t0 = _context9["catch"](0);
                error = _context9.t0;
                this.handleError((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.Detail, ErrorHandlingFromAPI.FromGetWaitlist);
                this.route = WaitListVisibityRoute.GET_WAITLIST_DETAILS_ERROR;
              // this.appMessages.showError(
              //   "Something went wrong",
              //   "Unable to load waitlist status",
              // );

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 7]]);
      }));

      function getWaitlistDataByVisitID(_x3, _x4, _x5) {
        return _getWaitlistDataByVisitID.apply(this, arguments);
      }

      return getWaitlistDataByVisitID;
    }()
  }, {
    key: "getWaitlistDataByVisitToken",
    value: function () {
      var _getWaitlistDataByVisitToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(token) {
        var _this$waitListVisibil54, _this$waitListVisibil55, _this$waitListVisibil56, _DPServices$Waitlist, payload, resp, _resp$visit, _resp$visit$location, _resp$visit2, _resp$visit2$location, _resp$visit3, _this$waitListVisibil57, _this$waitListVisibil58, _resp$visit4, localStatus, _error$response2, _error$response2$data, error;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                payload = {
                  tokenId: token,
                  concept: (_this$waitListVisibil54 = this.waitListVisibilityModel) === null || _this$waitListVisibil54 === void 0 ? void 0 : (_this$waitListVisibil55 = _this$waitListVisibil54.appAttributes) === null || _this$waitListVisibil55 === void 0 ? void 0 : (_this$waitListVisibil56 = _this$waitListVisibil55.concept) === null || _this$waitListVisibil56 === void 0 ? void 0 : _this$waitListVisibil56.conceptCode
                };
                _context10.next = 4;
                return DPServices === null || DPServices === void 0 ? void 0 : (_DPServices$Waitlist = DPServices.Waitlist) === null || _DPServices$Waitlist === void 0 ? void 0 : _DPServices$Waitlist.getVisitByToken(payload);

              case 4:
                resp = _context10.sent;

                if ("visit" in resp) {
                  this.waitListVisibilityModel.corporationID = resp === null || resp === void 0 ? void 0 : (_resp$visit = resp.visit) === null || _resp$visit === void 0 ? void 0 : (_resp$visit$location = _resp$visit.location) === null || _resp$visit$location === void 0 ? void 0 : _resp$visit$location.corporationID;
                  this.waitListVisibilityModel.locationNumber = resp === null || resp === void 0 ? void 0 : (_resp$visit2 = resp.visit) === null || _resp$visit2 === void 0 ? void 0 : (_resp$visit2$location = _resp$visit2.location) === null || _resp$visit2$location === void 0 ? void 0 : _resp$visit2$location.number; // Check if we have local status for the visit and return the status accordingly

                  localStatus = this._getLocalVisitStatus(resp, resp === null || resp === void 0 ? void 0 : (_resp$visit3 = resp.visit) === null || _resp$visit3 === void 0 ? void 0 : _resp$visit3.id);
                  resp.visit = _objectSpread(_objectSpread({}, resp === null || resp === void 0 ? void 0 : resp.visit), {}, {
                    status: localStatus
                  });
                  this.waitListVisibilityModel.setVisitData(resp === null || resp === void 0 ? void 0 : resp.visit);
                  this.waitListVisibilityModel.setFullWaitlist(resp === null || resp === void 0 ? void 0 : resp.waitlist); // if position exceeds the threshold returning to show check back later screen

                  this.checkIfUserPositionExceedsThreshold(((_this$waitListVisibil57 = this.waitListVisibilityModel) === null || _this$waitListVisibil57 === void 0 ? void 0 : (_this$waitListVisibil58 = _this$waitListVisibil57.fullWaitlist) === null || _this$waitListVisibil58 === void 0 ? void 0 : _this$waitListVisibil58.findIndex(function (item) {
                    return item.user;
                  })) + 1); // set from token and token value in the model

                  this.waitListVisibilityModel.token = token;
                  this.waitListVisibilityModel.isByVisitToken = true;
                  this.waitListVisibilityModel.visitID = resp === null || resp === void 0 ? void 0 : (_resp$visit4 = resp.visit) === null || _resp$visit4 === void 0 ? void 0 : _resp$visit4.id;
                }

                _context10.next = 13;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](0);
                error = _context10.t0;
                this.handleError((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.Detail, ErrorHandlingFromAPI.FromGetWaitlist);
                this.route = WaitListVisibityRoute.GET_WAITLIST_DETAILS_ERROR;
              // this.appMessages.showError(
              //   "Something went wrong",
              //   "Unable to load waitlist status",
              // );

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 8]]);
      }));

      function getWaitlistDataByVisitToken(_x6) {
        return _getWaitlistDataByVisitToken.apply(this, arguments);
      }

      return getWaitlistDataByVisitToken;
    }() // API call for checking in

  }, {
    key: "_doCheckin",
    value: function () {
      var _doCheckin2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this$waitListVisibil59, _this$waitListVisibil60, _this$waitListVisibil61, _this$waitListVisibil62, _this$waitListVisibil63, _this$waitListVisibil64, _this$waitListVisibil65, _this$waitListVisibil66;

        var _this$waitListVisibil67, _this$waitListVisibil68, _this$waitListVisibil69, _this$waitListVisibil70, _this$waitListVisibil71, _this$waitListVisibil72, _DPServices$Waitlist2, payload, resp, _this$waitListVisibil73, _this$waitListVisibil74, _this$waitListVisibil75, _this$waitListVisibil76, _this$waitListVisibil77, _this$waitListVisibil78, _this$waitListVisibil79, _this$waitListVisibil80, _this$waitListVisibil81, corporationID, locationNumber, visitID, _this$waitListVisibil82, _this$waitListVisibil83, _this$waitListVisibil84, _this$waitListVisibil85, _this$waitListVisibil86, _this$waitListVisibil87, _this$waitListVisibil88, _this$waitListVisibil89, _error$response3, _error$response4, _error$response4$data, _error$response5, _error$response5$data, error;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                // set page data for digitaldata object.
                this.analyticsModel.setPageAnalyticsDetails({
                  pageName: "".concat((_this$waitListVisibil59 = this.waitListVisibilityModel) === null || _this$waitListVisibil59 === void 0 ? void 0 : (_this$waitListVisibil60 = _this$waitListVisibil59.appAttributes) === null || _this$waitListVisibil60 === void 0 ? void 0 : (_this$waitListVisibil61 = _this$waitListVisibil60.concept) === null || _this$waitListVisibil61 === void 0 ? void 0 : (_this$waitListVisibil62 = _this$waitListVisibil61.conceptCode) === null || _this$waitListVisibil62 === void 0 ? void 0 : _this$waitListVisibil62.toLowerCase(), "|waitlist check-in|remote check-in"),
                  pageType: "".concat((_this$waitListVisibil63 = this.waitListVisibilityModel) === null || _this$waitListVisibil63 === void 0 ? void 0 : (_this$waitListVisibil64 = _this$waitListVisibil63.appAttributes) === null || _this$waitListVisibil64 === void 0 ? void 0 : (_this$waitListVisibil65 = _this$waitListVisibil64.concept) === null || _this$waitListVisibil65 === void 0 ? void 0 : (_this$waitListVisibil66 = _this$waitListVisibil65.conceptCode) === null || _this$waitListVisibil66 === void 0 ? void 0 : _this$waitListVisibil66.toLowerCase(), "|waitlist check-in|remote check-in")
                });
                _context11.prev = 1;
                payload = {
                  corporationId: (_this$waitListVisibil67 = this.waitListVisibilityModel) === null || _this$waitListVisibil67 === void 0 ? void 0 : _this$waitListVisibil67.corporationID,
                  visitId: (_this$waitListVisibil68 = this.waitListVisibilityModel) === null || _this$waitListVisibil68 === void 0 ? void 0 : _this$waitListVisibil68.visitID,
                  concept: (_this$waitListVisibil69 = this.waitListVisibilityModel) === null || _this$waitListVisibil69 === void 0 ? void 0 : (_this$waitListVisibil70 = _this$waitListVisibil69.appAttributes) === null || _this$waitListVisibil70 === void 0 ? void 0 : (_this$waitListVisibil71 = _this$waitListVisibil70.concept) === null || _this$waitListVisibil71 === void 0 ? void 0 : _this$waitListVisibil71.conceptCode,
                  locationNumber: parseInt((_this$waitListVisibil72 = this.waitListVisibilityModel) === null || _this$waitListVisibil72 === void 0 ? void 0 : _this$waitListVisibil72.locationNumber)
                }; // loading set to true

                this.waitListVisibilityModel.isCheckinLoading = true; // Check-in API call

                _context11.next = 6;
                return DPServices === null || DPServices === void 0 ? void 0 : (_DPServices$Waitlist2 = DPServices.Waitlist) === null || _DPServices$Waitlist2 === void 0 ? void 0 : _DPServices$Waitlist2.checkInVisit(payload);

              case 6:
                resp = _context11.sent;

                if (!("responseStatus" in resp)) {
                  _context11.next = 17;
                  break;
                }

                if (!(resp.responseStatus.status = "SUCCESS")) {
                  _context11.next = 17;
                  break;
                } // dispatch checkin event


                this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "remoteCheckIn", {}); // set success waitlist data into digitaldata object.

                this.analyticsModel.setWaitListData({
                  position: (_this$waitListVisibil73 = this.waitListVisibilityModel) === null || _this$waitListVisibil73 === void 0 ? void 0 : (_this$waitListVisibil74 = _this$waitListVisibil73.visitIdLocalStatus) === null || _this$waitListVisibil74 === void 0 ? void 0 : _this$waitListVisibil74.initialPosition.toString(),
                  numberOfGuests: "".concat((_this$waitListVisibil75 = this.waitListVisibilityModel) === null || _this$waitListVisibil75 === void 0 ? void 0 : (_this$waitListVisibil76 = _this$waitListVisibil75.visitData) === null || _this$waitListVisibil76 === void 0 ? void 0 : _this$waitListVisibil76.partySize),
                  waitTime: (_this$waitListVisibil77 = this.waitListVisibilityModel) === null || _this$waitListVisibil77 === void 0 ? void 0 : (_this$waitListVisibil78 = _this$waitListVisibil77.visitData) === null || _this$waitListVisibil78 === void 0 ? void 0 : (_this$waitListVisibil79 = _this$waitListVisibil78.quote) === null || _this$waitListVisibil79 === void 0 ? void 0 : _this$waitListVisibil79.exactTime,
                  token: (_this$waitListVisibil80 = this.waitListVisibilityModel) === null || _this$waitListVisibil80 === void 0 ? void 0 : _this$waitListVisibil80.token,
                  status: "successfully remote checked in"
                }); // call the getVisitById API

                _this$waitListVisibil81 = this.waitListVisibilityModel, corporationID = _this$waitListVisibil81.corporationID, locationNumber = _this$waitListVisibil81.locationNumber, visitID = _this$waitListVisibil81.visitID;
                _context11.next = 14;
                return this.getWaitlistDataByVisitID(corporationID, locationNumber, visitID);

              case 14:
                // Now showing confirmation page when user do checkin.
                // show confirmation on same checkin page
                this.route = WaitListVisibityRoute === null || WaitListVisibityRoute === void 0 ? void 0 : WaitListVisibityRoute.AUTO_CHECKIN_SUCCESS_WO_FWLV; // success modal set to true

                this.waitListVisibilityModel.showJoinWaitlistSuccessModal = true; // Change local status of the visit as checked in

                this.waitListVisibilityModel.visitIdLocalStatus = _objectSpread(_objectSpread({}, this.waitListVisibilityModel.visitIdLocalStatus), {}, {
                  localStatus: WaitListUserStatus.Arrived
                });

              case 17:
                this.waitListVisibilityModel.isCheckinLoading = false;
                _context11.next = 27;
                break;

              case 20:
                _context11.prev = 20;
                _context11.t0 = _context11["catch"](1);
                this.waitListVisibilityModel.isCheckinLoading = false; // Error on auto check in

                this.route = WaitListVisibityRoute.AUTO_CHECKIN_ERROR; // Error handler

                error = _context11.t0; // set success waitlist data into digitaldata object.

                this.analyticsModel.setWaitListData({
                  position: (_this$waitListVisibil82 = this.waitListVisibilityModel) === null || _this$waitListVisibil82 === void 0 ? void 0 : (_this$waitListVisibil83 = _this$waitListVisibil82.visitIdLocalStatus) === null || _this$waitListVisibil83 === void 0 ? void 0 : _this$waitListVisibil83.initialPosition.toString(),
                  numberOfGuests: "".concat((_this$waitListVisibil84 = this.waitListVisibilityModel) === null || _this$waitListVisibil84 === void 0 ? void 0 : (_this$waitListVisibil85 = _this$waitListVisibil84.visitData) === null || _this$waitListVisibil85 === void 0 ? void 0 : _this$waitListVisibil85.partySize),
                  waitTime: (_this$waitListVisibil86 = this.waitListVisibilityModel) === null || _this$waitListVisibil86 === void 0 ? void 0 : (_this$waitListVisibil87 = _this$waitListVisibil86.visitData) === null || _this$waitListVisibil87 === void 0 ? void 0 : (_this$waitListVisibil88 = _this$waitListVisibil87.quote) === null || _this$waitListVisibil88 === void 0 ? void 0 : _this$waitListVisibil88.exactTime,
                  token: (_this$waitListVisibil89 = this.waitListVisibilityModel) === null || _this$waitListVisibil89 === void 0 ? void 0 : _this$waitListVisibil89.token,
                  status: "got error while checking in",
                  errorMessage: {
                    status: "".concat(error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status),
                    data: error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : _error$response4$data.Detail
                  }
                });
                this.handleError((_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : (_error$response5$data = _error$response5.data) === null || _error$response5$data === void 0 ? void 0 : _error$response5$data.Detail, ErrorHandlingFromAPI.FromCheckinWaitlist);

              case 27:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[1, 20]]);
      }));

      function _doCheckin() {
        return _doCheckin2.apply(this, arguments);
      }

      return _doCheckin;
    }()
  }, {
    key: "refreshWaitTimeData",
    value: function refreshWaitTimeData() {// function executed on press of refresh button on pre checkin screen
    }
  }, {
    key: "refreshWaitlistData",
    value: function refreshWaitlistData() {
      // function executed on press of refresh button on full waitlist screen
      this.rootStore.platformUtil.navReload();
    }
  }, {
    key: "onPreorderDineInButtonPress",
    value: function onPreorderDineInButtonPress() {
      var _this$waitListVisibil90, _this$waitListVisibil91, _this$rootStore2, _this$rootStore2$plat, _this$rootStore4, _this$rootStore4$plat;

      var restaurantNumber = (_this$waitListVisibil90 = this.waitListVisibilityModel) === null || _this$waitListVisibil90 === void 0 ? void 0 : (_this$waitListVisibil91 = _this$waitListVisibil90.restaurantDetails) === null || _this$waitListVisibil91 === void 0 ? void 0 : _this$waitListVisibil91.restaurantNumber;
      var dineInMenuURL = "/menu?orderType=dinein&restaurantNum=".concat(restaurantNumber);

      if (((_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$plat = _this$rootStore2.platformUtil) === null || _this$rootStore2$plat === void 0 ? void 0 : _this$rootStore2$plat.PLATFORM_TYPE) === "APP") {
        var _this$rootStore3, _this$rootStore3$plat;

        (_this$rootStore3 = this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$plat = _this$rootStore3.platformUtil) === null || _this$rootStore3$plat === void 0 ? void 0 : _this$rootStore3$plat.navigateToRoute("/menu", [{
          name: "dineInObj",
          value: JSON.stringify({
            orderType: "dinein",
            restaurantNum: restaurantNumber
          })
        }]);
      } else (_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$plat = _this$rootStore4.platformUtil) === null || _this$rootStore4$plat === void 0 ? void 0 : _this$rootStore4$plat.navigateToRoute(dineInMenuURL);
    }
  }, {
    key: "navigateToRestaurantDetails",
    value: function navigateToRestaurantDetails() {
      var _this$waitListVisibil92, _this$waitListVisibil93, _this$waitListVisibil94, _this$waitListVisibil95, _this$waitListVisibil96, _this$waitListVisibil97, _this$waitListVisibil98, _this$waitListVisibil99, _this$rootStore5, _this$rootStore5$plat;

      var address = (_this$waitListVisibil92 = this.waitListVisibilityModel) === null || _this$waitListVisibil92 === void 0 ? void 0 : (_this$waitListVisibil93 = _this$waitListVisibil92.restaurantDetails) === null || _this$waitListVisibil93 === void 0 ? void 0 : (_this$waitListVisibil94 = _this$waitListVisibil93.contactDetail) === null || _this$waitListVisibil94 === void 0 ? void 0 : _this$waitListVisibil94.address;
      var restaurantName = (_this$waitListVisibil95 = this.waitListVisibilityModel) === null || _this$waitListVisibil95 === void 0 ? void 0 : (_this$waitListVisibil96 = _this$waitListVisibil95.restaurantDetails) === null || _this$waitListVisibil96 === void 0 ? void 0 : (_this$waitListVisibil97 = _this$waitListVisibil96.restaurantName) === null || _this$waitListVisibil97 === void 0 ? void 0 : _this$waitListVisibil97.toLowerCase();
      var restaurantNum = (_this$waitListVisibil98 = this.waitListVisibilityModel) === null || _this$waitListVisibil98 === void 0 ? void 0 : (_this$waitListVisibil99 = _this$waitListVisibil98.restaurantDetails) === null || _this$waitListVisibil99 === void 0 ? void 0 : _this$waitListVisibil99.restaurantNumber;
      var restDetailsURL = constructRestaurantDetailsUrl({
        state: address === null || address === void 0 ? void 0 : address.stateCode,
        city: address === null || address === void 0 ? void 0 : address.city,
        name: restaurantName,
        id: restaurantNum
      });
      (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$plat = _this$rootStore5.platformUtil) === null || _this$rootStore5$plat === void 0 ? void 0 : _this$rootStore5$plat.navigateToRoute(restDetailsURL);
    }
  }, {
    key: "leaveTheLine",
    value: function () {
      var _leaveTheLine = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this$rootStore6, _this$rootStore6$plat;

        var _this$waitListVisibil100, _this$waitListVisibil101, _this$waitListVisibil102, _this$waitListVisibil103, _this$waitListVisibil104, _this$waitListVisibil105, _DPServices$Waitlist3, payload, resp, _this$rootStore7, _this$rootStore7$plat, _this$rootStore8, _this$rootStore8$plat, _this$waitListVisibil106, _this$waitListVisibil107, _this$waitListVisibil108, _this$waitListVisibil109, _this$waitListVisibil110, _this$waitListVisibil111, _this$waitListVisibil112, _this$waitListVisibil113, _this$waitListVisibil114, _this$waitListVisibil115, _this$waitListVisibil116, _this$rootStore9, _this$rootStore9$plat, address, restaurantName, restaurantNum, restDetailsURL, _error$response6, _error$response6$data, error;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                //analytics when user cancels waitlist
                (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$plat = _this$rootStore6.platformUtil) === null || _this$rootStore6$plat === void 0 ? void 0 : _this$rootStore6$plat.dispatchEvent("AnalyticsEvent", "waitlistCancel", {});
                _context12.prev = 1;
                payload = {
                  corporationId: (_this$waitListVisibil100 = this.waitListVisibilityModel) === null || _this$waitListVisibil100 === void 0 ? void 0 : _this$waitListVisibil100.corporationID,
                  visitId: (_this$waitListVisibil101 = this.waitListVisibilityModel) === null || _this$waitListVisibil101 === void 0 ? void 0 : _this$waitListVisibil101.visitID,
                  concept: (_this$waitListVisibil102 = this.waitListVisibilityModel) === null || _this$waitListVisibil102 === void 0 ? void 0 : (_this$waitListVisibil103 = _this$waitListVisibil102.appAttributes) === null || _this$waitListVisibil103 === void 0 ? void 0 : (_this$waitListVisibil104 = _this$waitListVisibil103.concept) === null || _this$waitListVisibil104 === void 0 ? void 0 : _this$waitListVisibil104.conceptCode,
                  locationNumber: parseInt((_this$waitListVisibil105 = this.waitListVisibilityModel) === null || _this$waitListVisibil105 === void 0 ? void 0 : _this$waitListVisibil105.locationNumber),
                  checkVisitArrivalStatus: false
                };
                _context12.next = 5;
                return DPServices === null || DPServices === void 0 ? void 0 : (_DPServices$Waitlist3 = DPServices.Waitlist) === null || _DPServices$Waitlist3 === void 0 ? void 0 : _DPServices$Waitlist3.cancelVisit(payload);

              case 5:
                resp = _context12.sent;

                if (!resp) {
                  _context12.next = 25;
                  break;
                }

                if (!(((_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$plat = _this$rootStore7.platformUtil) === null || _this$rootStore7$plat === void 0 ? void 0 : _this$rootStore7$plat.PLATFORM_TYPE) === "APP")) {
                  _context12.next = 17;
                  break;
                }

                this.waitListVisibilityModel.showLeaveWaitlistModal = false;
                _context12.next = 11;
                return (_this$rootStore8 = this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$plat = _this$rootStore8.platformUtil) === null || _this$rootStore8$plat === void 0 ? void 0 : _this$rootStore8$plat.removeFromLocalStorage("hideEstimatedWaitTimeInJWC");

              case 11:
                this.rootStore.joinWaitlist.joinWaitlistModel.waitListId = "";
                this.rootStore.joinWaitlist.joinWaitlistModel.resetValues();
                _context12.next = 15;
                return this.rootStore.platformUtil.clearLocalStorage([// TODO(WL): confirm this -> shoud be WAITLIST_ID probably
                "WEB_AHEAD_ID", "WINE_WHILE_YOU_WAIT_INFO", "VISIT_ID", "JOIN_WAITLIST_TIMESTAMP"]);

              case 15:
                _context12.next = 25;
                break;

              case 17:
                address = (_this$waitListVisibil106 = this.waitListVisibilityModel) === null || _this$waitListVisibil106 === void 0 ? void 0 : (_this$waitListVisibil107 = _this$waitListVisibil106.restaurantDetails) === null || _this$waitListVisibil107 === void 0 ? void 0 : (_this$waitListVisibil108 = _this$waitListVisibil107.contactDetail) === null || _this$waitListVisibil108 === void 0 ? void 0 : _this$waitListVisibil108.address;
                restaurantName = (_this$waitListVisibil109 = this.waitListVisibilityModel) === null || _this$waitListVisibil109 === void 0 ? void 0 : (_this$waitListVisibil110 = _this$waitListVisibil109.restaurantDetails) === null || _this$waitListVisibil110 === void 0 ? void 0 : (_this$waitListVisibil111 = _this$waitListVisibil110.restaurantName) === null || _this$waitListVisibil111 === void 0 ? void 0 : _this$waitListVisibil111.toLowerCase();
                restaurantNum = (_this$waitListVisibil112 = this.waitListVisibilityModel) === null || _this$waitListVisibil112 === void 0 ? void 0 : (_this$waitListVisibil113 = _this$waitListVisibil112.restaurantDetails) === null || _this$waitListVisibil113 === void 0 ? void 0 : _this$waitListVisibil113.restaurantNumber;
                restDetailsURL = constructRestaurantDetailsUrl({
                  state: address === null || address === void 0 ? void 0 : address.stateCode,
                  city: address === null || address === void 0 ? void 0 : address.city,
                  name: restaurantName,
                  id: restaurantNum
                }); // change the local status of visit as cancelled

                this.waitListVisibilityModel.visitIdLocalStatus = {
                  visitId: (_this$waitListVisibil114 = this.waitListVisibilityModel) === null || _this$waitListVisibil114 === void 0 ? void 0 : _this$waitListVisibil114.visitID,
                  localStatus: WaitListUserStatus.Cancelled,
                  initialPosition: (_this$waitListVisibil115 = this.waitListVisibilityModel) === null || _this$waitListVisibil115 === void 0 ? void 0 : (_this$waitListVisibil116 = _this$waitListVisibil115.visitIdLocalStatus) === null || _this$waitListVisibil116 === void 0 ? void 0 : _this$waitListVisibil116.initialPosition
                }; // change the wl route to undefined

                this.route = null;
                this.waitListVisibilityModel.showLeaveWaitlistModal = false;
                (_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$plat = _this$rootStore9.platformUtil) === null || _this$rootStore9$plat === void 0 ? void 0 : _this$rootStore9$plat.navigateToRoute("".concat(restDetailsURL, "?from=cancel_waitlist"));

              case 25:
                _context12.next = 31;
                break;

              case 27:
                _context12.prev = 27;
                _context12.t0 = _context12["catch"](1); // Error handler

                error = _context12.t0;
                this.handleError((_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : (_error$response6$data = _error$response6.data) === null || _error$response6$data === void 0 ? void 0 : _error$response6$data.Detail, ErrorHandlingFromAPI.FromCancelWaitlist);

              case 31:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[1, 27]]);
      }));

      function leaveTheLine() {
        return _leaveTheLine.apply(this, arguments);
      }

      return leaveTheLine;
    }()
  }, {
    key: "shareStatus",
    value: function shareStatus() {// function executed on press of share status button on pre checkin footer
    }
  }, {
    key: "setUserStatus",
    value: function setUserStatus(status) {
      // if route is on error screen, there will be no need to set the status
      if (this.route === WaitListVisibityRoute.GET_WAITLIST_DETAILS_ERROR) {
        return;
      } // Not arrived -> need to do checkin


      if (status === WaitListUserStatus.NotYetArrived) {
        this.route = WaitListVisibityRoute.AUTO_CHECKIN_INPROGRESS;
      } // arrived -> checkin success, show full waitlist if available
      else if (status === WaitListUserStatus.Arrived) {
        var _this$waitListVisibil117; // After Checkin, show FW page, checkback soon page based on threshold
        // if position exceeds the threshold -> User should be displayed check back soon page.


        if ((_this$waitListVisibil117 = this.waitListVisibilityModel) !== null && _this$waitListVisibil117 !== void 0 && _this$waitListVisibil117.didUserPositionExceedsThreshold) {
          this.route = WaitListVisibityRoute.GUEST_EXCEEDS_WAITLIST_POSITION_THRESHOLD;
        } else if (this.waitListVisibilityModel.isFullWLVisibilityEnabled) {
          var _this$waitListVisibil118, _this$waitListVisibil119, _this$waitListVisibil120, _this$waitListVisibil121, _this$waitListVisibil122, _this$waitListVisibil123, _this$waitListVisibil124, _this$waitListVisibil125, _this$waitListVisibil126, _this$waitListVisibil127, _this$waitListVisibil128, _this$waitListVisibil129, _this$waitListVisibil130, _this$waitListVisibil131, _this$waitListVisibil132, _this$waitListVisibil133;

          this.route = WaitListVisibityRoute.FULL_WAITLIST_VISIBILITY; // set analytics data

          this.analyticsModel.setPageAnalyticsDetails({
            pageName: "".concat((_this$waitListVisibil118 = this.waitListVisibilityModel) === null || _this$waitListVisibil118 === void 0 ? void 0 : (_this$waitListVisibil119 = _this$waitListVisibil118.appAttributes) === null || _this$waitListVisibil119 === void 0 ? void 0 : (_this$waitListVisibil120 = _this$waitListVisibil119.concept) === null || _this$waitListVisibil120 === void 0 ? void 0 : (_this$waitListVisibil121 = _this$waitListVisibil120.conceptCode) === null || _this$waitListVisibil121 === void 0 ? void 0 : _this$waitListVisibil121.toLowerCase(), "|waitlist check-in|full waitlist visibility"),
            pageType: "".concat((_this$waitListVisibil122 = this.waitListVisibilityModel) === null || _this$waitListVisibil122 === void 0 ? void 0 : (_this$waitListVisibil123 = _this$waitListVisibil122.appAttributes) === null || _this$waitListVisibil123 === void 0 ? void 0 : (_this$waitListVisibil124 = _this$waitListVisibil123.concept) === null || _this$waitListVisibil124 === void 0 ? void 0 : (_this$waitListVisibil125 = _this$waitListVisibil124.conceptCode) === null || _this$waitListVisibil125 === void 0 ? void 0 : _this$waitListVisibil125.toLowerCase(), "|waitlist check-in|full waitlist visibility")
          });
          this.analyticsModel.setWaitListData({
            position: (_this$waitListVisibil126 = this.waitListVisibilityModel) === null || _this$waitListVisibil126 === void 0 ? void 0 : (_this$waitListVisibil127 = _this$waitListVisibil126.visitIdLocalStatus) === null || _this$waitListVisibil127 === void 0 ? void 0 : _this$waitListVisibil127.initialPosition.toString(),
            numberOfGuests: "".concat((_this$waitListVisibil128 = this.waitListVisibilityModel) === null || _this$waitListVisibil128 === void 0 ? void 0 : (_this$waitListVisibil129 = _this$waitListVisibil128.visitData) === null || _this$waitListVisibil129 === void 0 ? void 0 : _this$waitListVisibil129.partySize),
            waitTime: (_this$waitListVisibil130 = this.waitListVisibilityModel) === null || _this$waitListVisibil130 === void 0 ? void 0 : (_this$waitListVisibil131 = _this$waitListVisibil130.visitData) === null || _this$waitListVisibil131 === void 0 ? void 0 : (_this$waitListVisibil132 = _this$waitListVisibil131.quote) === null || _this$waitListVisibil132 === void 0 ? void 0 : _this$waitListVisibil132.exactTime,
            token: (_this$waitListVisibil133 = this.waitListVisibilityModel) === null || _this$waitListVisibil133 === void 0 ? void 0 : _this$waitListVisibil133.token
          });
        } else {
          this.route = WaitListVisibityRoute.AUTO_CHECKIN_SUCCESS_WO_FWLV;
        }
      } // seated -> user is in the seat
      else if (status === WaitListUserStatus.Seated) {
        this.route = WaitListVisibityRoute.GUEST_ALREADY_SEATED;
      } // completed -> user completed the waitlist
      else if (status === WaitListUserStatus.Completed) {
        this.route = WaitListVisibityRoute.GUEST_WAITLIST_COMPLETED;
      } else if (status === WaitListUserStatus.Cancelled) {
        this.route = WaitListVisibityRoute.GUEST_WAITLIST_CANCELLED;
      } else if (status === WaitListUserStatus.Notified) {
        this.route = WaitListVisibityRoute.GUEST_NOTIFIED;
      } // default case
      else {
        this.route = WaitListVisibityRoute.AUTO_CHECKIN_INPROGRESS;
      }
    }
  }, {
    key: "onLeaveWaitlistVisibility",
    // on back arrow press
    value: function onLeaveWaitlistVisibility() {
      var _this$rootStore10, _this$rootStore10$pla, _this$rootStore10$pla2; // will change after confirmation


      (_this$rootStore10 = this.rootStore) === null || _this$rootStore10 === void 0 ? void 0 : (_this$rootStore10$pla = _this$rootStore10.platformUtil) === null || _this$rootStore10$pla === void 0 ? void 0 : (_this$rootStore10$pla2 = _this$rootStore10$pla.navHistory()) === null || _this$rootStore10$pla2 === void 0 ? void 0 : _this$rootStore10$pla2.back();
    }
  }, {
    key: "checkIfUserPositionExceedsThreshold",
    value: function checkIfUserPositionExceedsThreshold(pos) {
      if (pos > parseInt(this.waitListVisibilityModel.maxWaitlistPostionThreshold)) {
        this.waitListVisibilityModel.didUserPositionExceedsThreshold = true;
      } else {
        this.waitListVisibilityModel.didUserPositionExceedsThreshold = false;
      }
    }
  }, {
    key: "doReloadOnError",
    value: function doReloadOnError() {
      // reloads the page
      this.rootStore.platformUtil.navReload();
    }
  }, {
    key: "_getLocalVisitStatus",
    value: function _getLocalVisitStatus(resp, visitId) {
      var _this$waitListVisibil134, _resp$visit5, _this$waitListVisibil135;

      var localStatus; // Local Visit ID

      var localVisitId = (_this$waitListVisibil134 = this.waitListVisibilityModel.visitIdLocalStatus) === null || _this$waitListVisibil134 === void 0 ? void 0 : _this$waitListVisibil134.visitId; // Visit ID statuses from both API and local

      var statusFromAPI = resp === null || resp === void 0 ? void 0 : (_resp$visit5 = resp.visit) === null || _resp$visit5 === void 0 ? void 0 : _resp$visit5.status;
      var statusFromLocal = (_this$waitListVisibil135 = this.waitListVisibilityModel.visitIdLocalStatus) === null || _this$waitListVisibil135 === void 0 ? void 0 : _this$waitListVisibil135.localStatus; // User Statuses

      var Arrived = WaitListUserStatus.Arrived;
      var NotYetArrived = WaitListUserStatus.NotYetArrived;
      var Cancelled = WaitListUserStatus.Cancelled; // if visit id is same as local will override the API response with local status.

      if (localVisitId === visitId) {
        // Override checks
        // Checkin -> API -> NotYet , local -> Arrived, final -> local
        // Cancel -> API -> Arrived, local -> Cancelled, final -> local
        // Cancel -> API -> Not, local -> Cancelled, final -> local
        // Others -> final -> API
        if (statusFromLocal === Arrived && statusFromAPI === NotYetArrived || statusFromLocal === Cancelled && statusFromAPI === Arrived || statusFromLocal === Cancelled && statusFromAPI === NotYetArrived) {
          localStatus = statusFromLocal;
        } else {
          var _this$waitListVisibil136, _this$waitListVisibil137;

          localStatus = statusFromAPI; // Update local storage with correct value

          this.waitListVisibilityModel.visitIdLocalStatus = {
            visitId: visitId,
            localStatus: statusFromAPI,
            initialPosition: (_this$waitListVisibil136 = this.waitListVisibilityModel) === null || _this$waitListVisibil136 === void 0 ? void 0 : (_this$waitListVisibil137 = _this$waitListVisibil136.visitIdLocalStatus) === null || _this$waitListVisibil137 === void 0 ? void 0 : _this$waitListVisibil137.initialPosition
          };
        }
      } // else store the new visitId and status
      else {
        this.waitListVisibilityModel.visitIdLocalStatus = {
          visitId: visitId,
          localStatus: statusFromAPI,
          initialPosition: resp.visit.placeInWaitlist
        };
        localStatus = statusFromAPI;
      }

      return localStatus;
    }
  }, {
    key: "handleError",
    value: function handleError(error, from) {
      if (error) {
        var _error$;

        var faultCode = error === null || error === void 0 ? void 0 : (_error$ = error[0]) === null || _error$ === void 0 ? void 0 : _error$.FaultCode; // if from waitlist API we will not show pop

        if (from === ErrorHandlingFromAPI.FromGetWaitlist) {
          // To catch visit id errors that are in process
          if (faultCode === "INSIGHTSERVICE-2") {
            this.waitListVisibilityModel.wlErrorCode = i18next.t("text.wle.waitlist_processing_error_heading", {
              defaultValue: "Still Processing"
            });
            this.waitListVisibilityModel.wlErrorMessage = i18next.t("text.wle.waitlist_processing_error_body", {
              defaultValue: "We are still processing your waitlist request, please try and checkin again in sometime"
            });
          } else {
            this.waitListVisibilityModel.wlErrorCode = "Error WL- ".concat(faultCode);
            this.waitListVisibilityModel.wlErrorMessage = i18next.t("text.wle.waitlist_error_body", {
              defaultValue: "Something went wrong, please try again"
            });
          }

          return;
        }

        var isFromCancelFlow = ErrorHandlingFromAPI.FromCancelWaitlist;
        var isFromCheckinFlow = ErrorHandlingFromAPI.FromCheckinWaitlist; // DRI-100 : service unavailable
        // DRI-102 : Connection Refused - While calling any backend service
        // DRI-103 : Read Timeout - While waiting for response of any backend service

        if (faultCode === "DRI-100" || faultCode === "DRI-102" || faultCode === "DRI-103") {
          this.appMessages.showError(i18next.t("error.rc.service_unavailable_header", {
            defaultValue: "Sorry"
          }), i18next.t("error.rc.service_unavailable_body", {
            defaultValue: "This Service is Unavailable right now."
          }));
        } // DRI-500 : Schema Validation
        // DRI-501 : Missing required field
        // DRI-550 : Invalid value in any field
        // DRI-570 : Provider Error


        if (faultCode === "DRI-500" || faultCode === "DRI-501" || faultCode === "DRI-550" || faultCode === "DRI-570") {
          this.appMessages.showError(i18next.t("error.rc.unable_to_proceess_header", {
            defaultValue: "Sorry"
          }), i18next.t("error.rc.unable_to_proceess_body", {
            defaultValue: "Something went wrong. We are unable to process your request."
          }));
        } // DRI-901 : Can't leave the waitlist


        if (isFromCancelFlow) {
          var errorHeader = i18next.t("error.rc.leave_line_header", {
            defaultValue: "Sorry"
          });

          if (faultCode === "DRI-901") {
            this.appMessages.showError(errorHeader, i18next.t("error.rc.leave_line_current_visit_body", {
              defaultValue: "The waitlist cannot be cancelled for the current visit"
            }));
          } else {
            this.appMessages.showError(errorHeader, i18next.t("error.rc.leave_line_body", {
              defaultValue: "Something went wrong. Unable to leave the waitlist"
            }));
          }
        }

        if (isFromCheckinFlow) {
          var errorHeading = i18next.t("error.rc.checkin_header", {
            defaultValue: "Sorry"
          }); // VISITSERVICE-601 : Visit has already arrived

          if (faultCode === "VISITSERVICE-601") {
            this.appMessages.showError(errorHeading, i18next.t("error.rc.checkin_visit_already_checkedin", {
              defaultValue: "Visit has already arrived."
            }));
          } // VISITSERVICE-602 : The WebAhead is no longer considered Active
          else if (faultCode === "VISITSERVICE-602") {
            this.appMessages.showError(errorHeading, i18next.t("error.rc.checkin_visit_not_active", {
              defaultValue: "The Visit is no longer considered Active."
            }));
          } // VISITSERVICE-603: Location does not support Visit Management
          else if (faultCode === "VISITSERVICE-603") {
            this.appMessages.showError(errorHeading, i18next.t("error.rc.checkin_location_not_supporting_visits", {
              defaultValue: "The location does not support visits."
            }));
          } // Default
          else {
            this.appMessages.showError(errorHeading, i18next.t("error.rc.checkin_body", {
              defaultValue: "Something went wrong. Unable to checkin."
            }));
          }
        }
      }
    }
  }, {
    key: "isOrderAheadEnabled",
    get: function get() {
      var _this$waitListVisibil138;

      return (_this$waitListVisibil138 = this.waitListVisibilityModel) === null || _this$waitListVisibil138 === void 0 ? void 0 : _this$waitListVisibil138.isOrderAheadEnabled;
    }
  }, {
    key: "isQualityStoryEnabled",
    get: function get() {
      var _this$waitListVisibil139, _this$waitListVisibil140;

      return !((_this$waitListVisibil139 = this.waitListVisibilityModel.restaurantDetails) !== null && _this$waitListVisibil139 !== void 0 && (_this$waitListVisibil140 = _this$waitListVisibil139.features) !== null && _this$waitListVisibil140 !== void 0 && _this$waitListVisibil140.disableQualityStory) && i18next.exists("text.joinwaitlist.quality.story.url");
    }
  }, {
    key: "route",
    set: function set(val) {
      var _this3 = this;

      runInAction(function () {
        _this3._route = val;
      });
    },
    get: function get() {
      return this._route;
    }
  }, {
    key: "userPositionInWaitlist",
    get: function get() {
      var _this$waitListVisibil141, _this$waitListVisibil142; // const userPosition =
      //   this?.waitListVisibilityModel?.visitData?.placeInWaitlist;
      // fix for backend not returning correct position if some visit data is lost


      var userPosition = ((_this$waitListVisibil141 = this.waitListVisibilityModel) === null || _this$waitListVisibil141 === void 0 ? void 0 : (_this$waitListVisibil142 = _this$waitListVisibil141.fullWaitlist) === null || _this$waitListVisibil142 === void 0 ? void 0 : _this$waitListVisibil142.findIndex(function (item) {
        return item.user;
      })) + 1;

      if (userPosition === 1) {
        return "next in line";
      }

      var j = userPosition % 10,
          k = userPosition % 100;

      if (j === 1 && k !== 11) {
        return userPosition + "<sup>st</sup>";
      }

      if (j === 2 && k !== 12) {
        return userPosition + "<sup>nd</sup>";
      }

      if (j === 3 && k !== 13) {
        return userPosition + "<sup>rd</sup>";
      }

      return userPosition + "<sup>th</sup>";
    }
  }]);

  return WaitListVisibility;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_route", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_storeName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "init", [action], Object.getOwnPropertyDescriptor(_class.prototype, "init"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "whenAppActive", [action], Object.getOwnPropertyDescriptor(_class.prototype, "whenAppActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderAheadEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderAheadEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isQualityStoryEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isQualityStoryEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "route", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "route"), _class.prototype)), _class);
export { WaitListVisibility as default };